<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Empresas'" :showBtn="false" :btnName="''" :btnRoute="''" :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loadingList"/>

            <!-- Filters -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div v-if="!loadingList" class="col-xs-12 col-sm-12 col-md-12 default-box filters">
                <form v-on:submit.prevent="getList()">
                  <div class="col-xs-12 col-sm-12 col-md-12">
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>ID da empresa</label>
                        <input v-model="dataSearch.id" type="text" class="form-control" id="id" name="id">
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>Nome da empresa</label>
                        <input v-model="dataSearch.name" type="text" class="form-control" id="name" name="name">
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>Tipo Pagamento</label> <select v-model="dataSearch.selectedPayment">
                        <option value="">Selecione</option>
                        <option value="0">Free/Trial</option>
                        <option value="1">CLIENTES free</option>
                        <option value="2">Até 10 funcionarios</option>
                        <option value="3">Acima 10 funcionarios</option>
                        <option value="5">Todos clientes Pagantes</option>
                        <option value="6">Todos</option>
                      </select>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>Tipo Status</label> <select v-model="dataSearch.selectedStatus">
                        <option value="">Selecione</option>
                        <option value="0">Todas</option>
                        <option value="1">Ativas</option>
                        <option value="2">Desativadas</option>
                      </select>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3 offset-top-10">
                      <div class="input-group input-with-date">
                        <label>Data Inicial</label>
                        <datepicker ref="programaticOpen3" v-model="dataSearch.initialDate" :language="ptBR"
                                    :format="customFormatter"/>
                        <i v-on:click="openCalendar3()" class="fa fa-calendar" aria-hidden="true"></i>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3 offset-top-10">
                      <div class="input-group input-with-date">
                        <label>Data Final</label>
                        <datepicker ref="programaticOpen4" v-model="dataSearch.finalDate" :language="ptBR"
                                    :format="customFormatter"/>
                        <i v-on:click="openCalendar4()" class="fa fa-calendar" aria-hidden="true"></i>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3 offset-top-10">
                      <div class="form-group">
                        <label for="cnpj">CNPJ</label>
                        <input v-model="dataSearch.cnpj" type="text" class="form-control" id="cnpj" name="cnpj"
                               v-mask="['##.###.###/####-##']">
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3 offset-top-10">
                      <div class="form-group">
                        <label for="email">E-mail</label>
                        <input v-model="dataSearch.email" type="text" class="form-control" id="email" name="email">
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3 offset-top-10">
                      <div class="form-group">
                        <label>Produtos</label> <select v-model="dataSearch.moduleType">
                        <option value="0">Ponto</option>
                        <option value="1">Benefícios</option>
                        <option value="2">Benefícios + Ponto</option>
                        <option value="3">Todos</option>
                      </select>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3 offset-top-10">
                      <div class="form-group">
                        <label>Jornada do cliente</label> <select v-model="dataSearch.clientJourney">
                        <option value="">Todos</option>
                        <option value="0">Lead</option>
                        <option value="1">Onboarding</option>
                        <option value="2">Middle</option>
                        <option value="3">Ongoing</option>
                      </select>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3 offset-top-10">
                      <div class="form-group total-employee">
                        <label>Quantidade de colaboradores</label>
                        <div class="input-qtd">
                          <span>De:</span>
                          <input v-model="dataSearch.qtdMin" type="text" class="form-control" id="qtdMin" name="qtdMin"
                                 v-mask="'######'">
                          <span>Até</span>
                          <input v-model="dataSearch.qtdMax" type="text" class="form-control" id="qtdMax" name="qtdMax"
                                 v-mask="'######'">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-12 offset-top-10">
                    <button type="submit">Pesquisar</button>
                  </div>
                </form>
              </div>
            </div>

            <!-- No Result -->
            <div v-if="!loadingList && (dataCompany !== '' && !dataCompany.length) && !failRequest"
                 class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Sem resultado na pesquisa.</p>
              </div>
            </div>

            <!-- Fail Request -->
            <div v-if="!loadingList && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Falha na requisição.</p>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loadingList && dataCompany.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box orderBy">
                <div class="portlet-title">
                  <div class="caption">
                  <span class="caption-subject font-blue bold uppercase">
                    Quantidade total de empresas
                    ({{ dataCompany.length }})
                  </span>
                  </div>

                  <a v-on:click="downloadActualListExcel()" class="btn-all-excel right" title="Imprimir">
                    <span>Gerar Excel</span> <i class="fa fa-file-excel-o" aria-hidden="true"></i> </a>

                  <div class="orderBy">
                    <label> Ordem por: <select v-model="orderByValue">
                      <option value="name">Nome</option>
                      <option value="createdAt">Data de Criação</option>
                      <option value="expiratedAt">Data de Expiração</option>
                      <option value="totalEmployee">Qtd Fun.</option>
                    </select> </label>
                  </div>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-light table-icon">
                      <thead>
                      <tr>
                        <th> NOME</th>
                        <th> EMAIL</th>
                        <th> TELEFONE</th>
                        <th> QTD DE FUN.</th>
                        <th> JORNADA</th>
                        <th> SOLUÇÕES</th>
                        <th> ATIVO</th>
                        <th> CADASTRADO</th>
                        <th> EXPIRA</th>
                        <th> AÇÕES</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(c, index) in orderBy(dataCompany, orderByValue)" :key="index">
                        <td>{{ c.name }}</td>
                        <td>{{ c.email }}</td>
                        <td>{{ c.phone }}</td>
                        <td>{{ c.totalEmployee }}</td>
                        <td>
                           <span class="tag-benefits-list" style="background-color: #FF5531;"
                                 v-if="c.clientJourney === 0">
                            {{ c.clientJourneyStr }}
                          </span>
                          <span class="tag-benefits-list" style="background-color: #BB3AD0;"
                                v-if="c.clientJourney === 1">
                            {{ c.clientJourneyStr }}
                          </span>
                          <span class="tag-benefits-list" style="background-color: #FF9999 ;"
                                v-if="c.clientJourney === 2">
                            {{ c.clientJourneyStr }}
                          </span>
                          <span class="tag-benefits-list" style="background-color: #52C977;"
                                v-if="c.clientJourney === 3">
                            {{ c.clientJourneyStr }}
                          </span>
                        </td>
                        <td>
                          <span class="tag-benefits-list" style="background-color: #3598DC;" v-if="c.moduleType === 0">
                            {{ c.moduleTypeStr }}
                          </span>
                          <span class="tag-benefits-list" style="background-color: #265389 ;" v-if="c.moduleType === 1">
                            {{ c.moduleTypeStr }}
                          </span>
                          <span class="tag-benefits-list" style="background-color: #4EB934;" v-if="c.moduleType === 2">
                            {{ c.moduleTypeStr }}
                          </span>
                        </td>
                        <td>
                          <span v-if="c.isActive === 'Ativo'" class="active">{{ c.isActive }}</span>
                          <span v-else class="disabled">{{ c.isActive }}</span>
                        </td>
                        <td>{{ c.createdAt | formatFullDate }}</td>
                        <td>{{ c.expiratedAt | formatDate }}</td>
                        <td class="no-wrap">
                          <a @click="goToFunil(c)" title="Visualizar" class="btn-to-view">
                            <i class="fa fa-eye" aria-hidden="true"></i> Visualizar </a>
                          <a v-if="c.isActive === 'Desativada'"
                             v-bind:href="'http://marqponto.com.br/cancelamento#' + c.contextCode + '&' + c.id"
                             title="Link de cancelamento para o cliente" class="btn-to-view" target="_blank">
                            <i class="fa fa-eye" aria-hidden="true"></i> Link de cancelamento </a>
                          <a v-if="c.isActive === 'Desativada' || c.plan === 'Cliente em Teste'"
                             v-on:click="activeModal(c);" title="Ativar/Desativar" class="btn-to-delete">

                            <i v-if="c.isActive === 'Desativada'" class="fa fa-check" aria-hidden="true">
                              <span> Ativar</span> </i> <i v-else class="fa fa-ban" aria-hidden="true">
                            <span> Desativar</span> </i> </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <!--modal validation password-->
                    <div class="modal fade" id="password-modal" role="dialog">
                      <div class="modal-dialog">
                        <div class="modal-content">
                          <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal">
                              &times;
                            </button>
                            <h4 class="title-modal">Confirmação de Permissão</h4>
                          </div>
                          <div class="modal-body text-center">
                            <div class="form-group">
                              <h4 class="text-danger">
                                <b>NÂO USAR ESSE BOTÂO PARA DAR CHURN</b>
                              </h4>
                            </div>
                            <div class="form-group">
                              <h4>Digite a senha para ter acesso</h4>
                            </div>
                            <input type="password" id="input-password" class="form-control" onfocus="this.value=''"
                                   v-model="modalPassword" autocomplete="off" placeholder="Password">
                            <button class="btn btn-register" @click="modalConfirmation(companySelected)"
                                    data-dismiss="modal" data-backdrop="false">Confirmar
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import swal from 'sweetalert';
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pageHeader from "../../components/default/pageHeader.vue";

import {
  ALL_COMPANY,
  DESACTIVE_ACTIVE,
  COMPANY_CHANCE_DADE_INFO,
  ENABLE_BENEFITS, GET_DATA_TO_FUNIL
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../../msgAlertService";
import moment from "moment";
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import datepicker from "vuejs-datepicker";
import {target} from "vuelidate/lib/params";

export default {
  name: "all-company",
  components: {
    topMenu,
    datepicker,
    pageHeader,
    fullLoading
  },
  data() {
    return {
      companySelected: "",
      modalPassword: "",
      ptBR: ptBR,
      failRequest: false,
      loadingList: false,
      orderByValue: "name",
      orderByValuePlan: "2",
      dataCompany: '',
      dataCompanyUsers: '',
      dataSearch: {
        id: '',
        name: '',
        initialDate: '',
        finalDate: '',
        selectedPayment: '',
        selectedStatus: 1,
        cnpj: '',
        email: '',
        moduleType: '3',
        clientJourney: '',
        qtdMin: '',
        qtdMax: '',
      },
      listOrder: []
    }
  },

  methods: {
    goToFunil(c) {
      let url = GET_DATA_TO_FUNIL + c.id;
      REQUEST_SERVICE.requestContext("GET", url, c.contextCode)
        .then((response) => {
          UTIL_SERVICE.console("RESULT GET_DATA_TO_FUNIL:", response.data);

          window.open(
            "/empresa-detalhes-funil/" +
            response.data.pipelineId +
            "/" +
            response.data.id,
            "_blank"
          );
        })
        .catch(() => {
          window.open(
            "/detalhes-da-empresa/" + c.id + "/" + c.contextCode,
            "_blank"
          )
        });
    },
    refreshUser() {
      const typeCategory = this.$route.params.type;

      switch (typeCategory) {
        case '2':
          this.dataSearch.name = this.$route.params.value;
          break;
        case '3':
          this.dataSearch.cnpj = this.$route.params.value;
          break;
      }
    },
    openCalendar3: function () {
      this.$refs.programaticOpen3.showCalendar();
    },
    openCalendar4: function () {
      this.$refs.programaticOpen4.showCalendar();
    },
    customFormatter(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    downloadActualListExcel() {
      let bodyValue = [];
      this.listOrder.map((value, index) => {
        bodyValue.push([value.id, value.name, value.phone, value.email, value.totalEmployee, value.plan, value.cnpj, value.contextCode, value.isActive, moment(String(value.createdAt)).format('DD/MM/YYYY'), moment(String(value.expiratedAt)).format('DD/MM/YYYY')]);

        if (index + 1 === this.listOrder.length) {
          let headValue = ["ID", "EMPRESA", "TELEFONE", "EMAIL", "QTD FUNCIONÁRIOS", "PLANO", "CNPJ", "BANCO", "ATIVO?", "DATA INÍCIO", "DATA EXPIRAÇÃO"];

          window.downloadListExcel(headValue, bodyValue, "Lista de empresas");
        }
      });
    },
    getList() {
      this.loadingList = true;
      let url = ALL_COMPANY + "?t=kkkk";
      const objSend = {
        t: 'kkkk'
      };

      if (this.dataSearch.selectedPayment)
        objSend.payment = this.dataSearch.selectedPayment;
      else
        objSend.payment = "6";
      if (this.dataSearch.selectedStatus)
        objSend.type = this.dataSearch.selectedStatus;
      else
        objSend.type = "0";
      if (this.dataSearch.name)
        objSend.name = this.dataSearch.name;
      if (this.dataSearch.id)
        objSend.id = this.dataSearch.id;
      if (this.dataSearch.cnpj)
        objSend.cnpj = this.dataSearch.cnpj;
      if (this.dataSearch.email)
        objSend.email = this.dataSearch.email;
      if (this.dataSearch.moduleType)
        objSend.moduleType = this.dataSearch.moduleType;
      if (this.dataSearch.clientJourney)
        objSend.clientJourney = this.dataSearch.clientJourney;
      if (this.dataSearch.initialDate)
        objSend.init = moment(this.dataSearch.initialDate).format("YYYY-MM-DD");
      if (this.dataSearch.finalDate)
        objSend.end = moment(this.dataSearch.finalDate).format("YYYY-MM-DD");

      if (this.dataSearch.qtdMin && this.dataSearch.qtdMax) {
        objSend.minEmployee = this.dataSearch.qtdMin;
        objSend.maxEmployee = this.dataSearch.qtdMax;
      }

      if (this.dataSearch.qtdMin && !this.dataSearch.qtdMax) {
        objSend.minEmployee = this.dataSearch.qtdMin;
        objSend.maxEmployee = '999999';
      }

      if (!this.dataSearch.qtdMin && this.dataSearch.qtdMax) {
        objSend.minEmployee = '1';
        objSend.maxEmployee = this.dataSearch.qtdMax;
      }

      UTIL_SERVICE.console("URL SEARCH:", objSend);
      REQUEST_SERVICE.post(url, objSend).then((response) => {
        UTIL_SERVICE.console("RESULT ALL_COMPANY:", response.data);

        this.dataCompany = response.data;
        this.listOrder = response.data.slice().sort(function (a, b) {
          return a.totalEmployee - b.totalEmployee;
        }).reverse();
        this.loadingList = false;
      }).catch((reason) => {
        this.loadingList = false;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    activeModal(company) {
      this.modalPassword = '';
      this.companySelected = company;
      $("#password-modal").modal();
    },
    activeOrDisableCompany(company) {
      if (company.isActive === 'Desativada' || company.plan === 'Cliente em Teste') {

        swal({
          title: "Aviso",
          text: "Você tem certeza que deseja executar essa ação na empresa:" + company.name + "\n\n\n Qual motivo?",
          icon: "warning",
          buttons: true,
          dangerMode: true,
          content: {
            element: "div",
            attributes: {
              innerHTML: `
                <input type="text" id="reason" class="swal-content__input" placeholder="Qual motivo?">
                <div class="swal-box__inputs">
                    <input type="checkbox" id="reactivate">
                    <label for="reactivate" class="">Reativado como novo cliente?</label>
                </div>`,
            }
          },
        })
          .then((value) => {
            let checkbox = document.getElementById("reactivate");
            let inputText = document.getElementById("reason");
            if (value) {
              if (inputText.value) {
                this.loadingList = true;
                let url = DESACTIVE_ACTIVE + "?i=" + company.id + "&motive=" + inputText.value + "&reactivatedByNewClient=" + checkbox.checked;
                REQUEST_SERVICE.requestContext('GET', url, company.contextCode).then((response) => {
                  UTIL_SERVICE.console("RESULT DESACTIVE_ACTIVE:", response.data);
                  ALERT_SERVICE.swal("Aviso", response.data, "success");
                  this.getList();
                }).catch((reason) => {
                  this.loadingList = false;
                  swal('Aviso', reason.response.data.erros[0].value, 'error');
                });
              } else {
                swal('Aviso', 'Preencha o motivo para continuar!')
              }
            } else {
              swal('Aviso', 'Operação cancelada')
            }
          });
      } else {
        swal('Aviso', "")
      }
    },
    modalConfirmation(company) {
      UTIL_SERVICE.console("DATA COMPANY:", company);

      if (this.modalPassword === 'financeiro@1234') {
        $("#password-modal").toggle("");
        this.activeOrDisableCompany(company)
        $("#modalChurn").modal();
        this.modalPassword = '';
      } else {
        $("#password-modal").toggle("");
        swal("Aviso", "Senha Errada!", "error");
        this.modalPassword = '';
      }
    }
  },
  beforeMount() {
    this.refreshUser();
  }
}
</script>

<style lang="scss">

.swal-box__inputs {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 2px;
}

.total-employee {
  .input-qtd {
    display: flex;
    align-items: center;
    gap: 3%;
  }
}

.btn-all-excel {
  cursor: pointer;
  display: inline-block;
  padding: 6px 10px 5px;
  margin-left: 10px;
  background-color: #00A651;
  color: #FFF;
  margin-bottom: 20px;
  border-radius: 4px !important;
  float: right;
  font-weight: 600;
  margin-top: 0;
  border: none;

  i {
    margin-left: 5px;
  }

  &:hover {
    color: #FFF;
    background-color: #008D45;
  }
}

.tag-benefits-list {
  padding: 2px 8px !important;
  border-radius: 4px !important;
  display: flex;
  margin: 0;
  color: #FFFFFF !important;
  justify-content: center;
  width: 95%;

  &:hover {
    cursor: auto;
  }
}

.contate-table {
  .active {
    background: #00A651;
    color: #FFFFFF;
    display: block;
    width: 100%;
    text-align: center;
    border-radius: 4px !important;
    height: 24px;
    padding: 0 10px;
    line-height: 25px;
  }

  .disabled {
    background: #E8505B;
    color: #FFFFFF;
    display: block;
    width: 100%;
    text-align: center;
    border-radius: 4px !important;
    height: 24px;
    padding: 0 10px;
    line-height: 25px;
  }
}

.input-with-date {
  width: 100%;

  input {
    width: 100%;
  }
}

#password-modal {
  .error-msg {
    font-size: 12px;
    color: #E74A4E;
    text-align: left;
    display: block;
  }

  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }

  .modal-body {
    padding-left: 80px;
    padding-right: 80px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .title-modal {
    text-align: center;
    padding-top: 10px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .btn-register {
    border-radius: 4px !important;
    background-color: #3598DC;
    padding: 7px 35px 7px 35px;
    font-weight: 600;
    text-align: center;
    color: #FFF;
    border: none;
    height: 36px;
    margin-top: 10px;
  }

  .close-btn {
    border-radius: 4px !important;
    background-color: #8B8787;
    padding: 7px 35px 7px 35px;
    font-weight: 600;
    text-align: center;
    color: #FFF;
    border: none;
    height: 36px;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/allCompany/allCompany.vue